import { Box, MenuItem, Select, Skeleton, Typography, Button } from "@mui/material";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect } from "react";
import axios from "axios";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DownloadIcon from "@mui/icons-material/Download";
import veg from "../Assets/product_management/Foodmark.svg";
import nonVeg from "../Assets/product_management/non-veg.svg";
import * as XLSX from 'xlsx';
import {
  updateInventoryDetail,
  updateInventoryDetailsModal,
  updateInventryHubsupervisors,
  updateallInventryDetails,
  updateinventoryDetailsEdit,
} from "../Redux/inventory";
import { useState } from "react";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import Tooltip from "@mui/material/Tooltip";
import {
  updateOrderDetails,
  updateOrderModel,
  updateOrders,
  updatePartnerAssignModal,
  updateUpdatedDate,
  updateselectedDeliveryPartner,
  updatefilteredOrders,
} from "../Redux/orders";
import CustomAxios from "../utils/CustomAxios";
import { useFetchOrders, useGetOrders } from "../Components/globalFunctions";

export function OrderListTable() {
  const toast = useRef(null);
  const search = useSelector((state) => state.page.searchOrders);
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.orders.orders);
  const updatedDate = useSelector((state) => state.orders.updatedDate);
  const orderList = useSelector((state) => state.orders.filteredOrders);
  const partners = useSelector((state) => state.orders.deliveryPartners);
  const inventoryDetails = useSelector(state => state.inventory.allInventryDetails);
  const inventories = useSelector(state => state.inventory.inventory);
  const hub_ID = useSelector(state => state.user.selected_hub);
  const selectedDeliveryPartner = useSelector(
    (state) => state.orders.selectedDeliveryPartner
  );
  const loading = useSelector((state) => state.orders.loading);
  const selectedStalls = useSelector((state) => state.orders.selectedStalls) || [];
  const selectedCategories = useSelector((state) => state.orders.selectedCategories) || [];
  const memberFilter = useSelector((state) => state.orders.memberFilter) || 'all';
  const statusFilter = useSelector((state) => state.orders.statusFilter) || 'all';
  const [isOrderd, setisOrderd] = useState(false);
  const inventory_id = useSelector((state) => state.inventory.selectedInventoryId);
  const selectedDate = useSelector((state) => state.orders.selectedDate);
  const userRole = localStorage.getItem('role');
  const getPaymentDisplay = (order) => {
    const candidates = [
      order.paymentmethod,
      order.payment_method,
      order.paymentMode,
      order.payment_mode,
      order.paymentgateway,
      order.payment_gateway,
      order.paymentdetails?.payment_gateway,
      order.paymentdetails?.payment_method
    ];
    const raw = candidates.find(val => typeof val === 'string' && val.trim().length > 0) || "--";
    const normalized = typeof raw === 'string' ? raw.toLowerCase() : '';
    if (userRole === 'cashier' && normalized.includes('razor')) {
      return "--";
    }
    return raw;
  };

  const getStallName = (order = {}) => {
    const candidates = [
      order.stall?.stall_name,
      order.stall_name,
      order.selected_stall?.stall_name,
      typeof order.selected_stall === "string" ? order.selected_stall : null,
      order.delivery_address?.street,
      order.delivery_address?.stall_name,
      order.delivery_address?.hub_name,
    ];

    return (
      candidates.find(
        (value) => typeof value === "string" && value.trim().length > 0
      ) || ""
    );
  };
  
  const [displayOrders, setDisplayOrders] = useState(orderList);
  // Determine if currently selected hub belongs to Foodfix franchise (id 2)
  const isFoodfix = (() => {
    const stored = localStorage.getItem('selected_franchise_id');
    const id = stored ? parseInt(stored, 10) : null;
    return id === 2; // Foodfix
  })();

  useEffect(() => {
    // if (orderList.length > 0) {
      setDisplayOrders(orderList);
    // }
  }, [orderList]);
  
  // Stall filtering for FoodFix
  const showStallFilter = useSelector((state) => state.orders.showStallFilter);
  const getNormalizedCategory = (category) => {
    if (category && typeof category === 'object') {
      return category.category_name || category.id || category.label;
    }
    return category;
  };
  const selectedCategoryLabels = selectedCategories
    .map(getNormalizedCategory)
    .filter(Boolean)
    .map((cat) => cat.toString().toLowerCase());

  const getOrderCategories = (order) => {
    if (!order?.cart_items || !Array.isArray(order.cart_items)) {
      return [];
    }
    const categories = new Set();
    order.cart_items.forEach((cartItem) => {
      const productDetailsArray = Array.isArray(cartItem.product_details)
        ? cartItem.product_details
        : cartItem.product_details
          ? [cartItem.product_details]
          : [];
      productDetailsArray.forEach((product) => {
        if (product?.item_category) {
          categories.add(product.item_category);
        }
      });
    });
    return Array.from(categories);
  };

  const getOrderCategoryLabel = (order) => {
    const orderCategories = getOrderCategories(order);
    if (!orderCategories.length) return null;
    if (selectedCategoryLabels.length) {
      const match = orderCategories.find((cat) =>
        selectedCategoryLabels.includes(cat.toString().toLowerCase())
      );
      if (match) return match;
    }
    return orderCategories[0];
  };

  const GetOrders = useGetOrders();
  const fetchOrders = useFetchOrders();

  /*
   * Whether anything is filtering at all.
   *
   * When nothing is, the raw list is rendered and the filtered copy ignored —
   * so a filter missing from this list silently does nothing. The status filter
   * was added without being added here, which is why choosing a status changed
   * the table not at all.
   */
  const hasActiveFilters =
    selectedStalls.length > 0 ||
    selectedCategories.length > 0 ||
    memberFilter === 'member' ||
    memberFilter === 'non_member' ||
    (!!statusFilter && statusFilter !== 'all');
  const visibleOrders = (hasActiveFilters ? displayOrders : orderList) || [];
  const showSkeletonPlaceholder = loading || (isOrderd && visibleOrders.length === 0);

  // Function to filter orders by selected stalls
  const filterOrdersByStalls = (ordersList) => {
    console.log('🍽️ Filtering function called:', {
      selectedStalls: selectedStalls.map(s => typeof s === 'object' ? { id: s.id, name: s.stall_name } : { id: s, name: 'Unknown' }),
      ordersCount: ordersList.length,
      showStallFilter
    });
    
    if (selectedStalls.length === 0) {
      console.log('🍽️ No stalls selected, returning all orders');
      return ordersList;
    }
    
    // Debug: Show first order structure to understand the data
    if (ordersList.length > 0) {
      console.log('🍽️ First order structure:', {
        orderId: ordersList[0].id,
        orderKeys: Object.keys(ordersList[0]),
        stall_id: ordersList[0].stall_id,
        stall: ordersList[0].stall,
        selected_stall: ordersList[0].selected_stall
      });
    }
    
    const filtered = ordersList.filter(order => {
      // Try different possible field names for stall ID
      const orderStallId = order.stall_id;
      
      // Handle both stall objects and stall IDs in selectedStalls
      const matches = selectedStalls.some(stall => {
        // If stall is an object, use stall.id, otherwise use stall directly (if it's just an ID)
        const selectedStallId = typeof stall === 'object' ? stall.id : stall;
        const match = selectedStallId === orderStallId;
        console.log(`🍽️ Order ${order.id} (stall_id: ${orderStallId}) vs Selected Stall ${selectedStallId} matches:`, match);
        return match;
      });
      return matches;
    });
    
    console.log('🍽️ Filtered orders result:', filtered.length, 'out of', ordersList.length);
    return filtered;
  };

   // Function to filter orders by selected categories
   const filterOrdersByCategories = (ordersList) => {
    if (selectedCategories.length === 0) {
      return ordersList;
    }

    const normalizedCategories = selectedCategories.map(getNormalizedCategory).filter(Boolean);

    if (normalizedCategories.length === 0) {
      return ordersList;
    }

    return ordersList.filter(order => {
      if (!order.cart_items || !Array.isArray(order.cart_items)) {
        return false;
      }

      return order.cart_items.some(cartItem => {
        const productDetailsArray = Array.isArray(cartItem.product_details)
          ? cartItem.product_details
          : cartItem.product_details
            ? [cartItem.product_details]
            : [];

        return productDetailsArray.some(product => normalizedCategories.includes(product.item_category));
      });
    });
  };


  // Effect to apply stall / category / member filtering
  useEffect(() => {
    console.log('🍽️ Filter effect triggered:', {
      selectedStalls: selectedStalls.length,
      selectedCategories: selectedCategories.length,
      memberFilter,
      ordersCount: orders.length
    });

    let filteredOrders = orderList;

    if (selectedStalls.length > 0) {
      filteredOrders = filterOrdersByStalls(filteredOrders);
    }

    if (selectedCategories.length > 0) {
      filteredOrders = filterOrdersByCategories(filteredOrders);
    }

    if (memberFilter === 'member') {
      filteredOrders = filteredOrders.filter((order) => !!order.is_member_order);
    } else if (memberFilter === 'non_member') {
      filteredOrders = filteredOrders.filter((order) => !order.is_member_order);
    }

    // Status filter. Compared case-insensitively because the column is written
    // by several code paths and is not consistently cased.
    if (statusFilter && statusFilter !== 'all') {
      const wanted = String(statusFilter).toLowerCase();
      filteredOrders = filteredOrders.filter(
        (order) => String(order?.status || '').toLowerCase() === wanted
      );
    }

    setDisplayOrders(filteredOrders);
  }, [selectedStalls, selectedCategories, memberFilter, statusFilter, orderList]);

  useEffect(() => {
    if (hub_ID) {
      // fetchOrdersBasedOnHub();
    }
  }, [hub_ID]);

  const fetchOrdersBasedOnHub = async () => {
    const selectedHubRaw = localStorage.getItem('selected_hub')
    const userRole = localStorage.getItem('role');
    
    try {
      let response;
      let ordersData;

      if (userRole === 'super_admin') {
        // Super admin uses getAllOrders endpoint to get all orders
        response = await CustomAxios.get(`get_all_orders/`);
        ordersData = {
          current_orders: response.data.filter(order => 
            !['delivered', 'cancelled', 'declined', 'picked'].includes(order.status) && order.payment_status === true
          ),
          history_orders: response.data.filter(order => 
            ['delivered', 'cancelled', 'declined', 'picked'].includes(order.status) && order.payment_status === true
          ),
          response: true
        };
      } else {
        // Other roles use inventory-specific endpoint
        let selectedHub;
        try {
          const parsedHub = JSON.parse(selectedHubRaw || '[]');
          if (Array.isArray(parsedHub) && parsedHub.length > 0) {
            selectedHub = parsedHub[0];
          } else {
            selectedHub = parsedHub;
          }
        } catch (error) {
          selectedHub = selectedHubRaw;
        }

        response = await CustomAxios.get(`get_all_orders_inventory/${selectedHub}/`);
        ordersData = response.data;
      }

      console.log("order data ------------", ordersData, ordersData.response === true && ordersData.current_orders?.length > 0);

      if (ordersData.response === true && ordersData.current_orders?.length > 0) {
        setisOrderd(true);
        dispatch(updateOrders(ordersData.current_orders));
        dispatch(updatefilteredOrders(ordersData.current_orders));
      } else {
        console.log("No orders found for hub:", hub_ID);
        setisOrderd(false);
        dispatch(updateOrders([]));
        dispatch(updatefilteredOrders([]));
      }
    } catch (err) {
      console.error("Error fetching orders", err);
      setisOrderd(false);
      dispatch(updateOrders([]));
      dispatch(updatefilteredOrders([]));
    }
  };


  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    const day = String(dateObject.getDate()).padStart(2, "0");
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const year = dateObject.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatTime = (dateString) => {
    const dateObject = new Date(dateString);
    let hours = dateObject.getHours();
    const minutes = String(dateObject.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    hours = String(hours).padStart(2, "0");
    return `${hours}:${minutes} ${ampm}`;
  };

  const handleStatusChange = async (id, newStatus, item) => {
    try {
      await CustomAxios.put(`checkout/update/${id}/`, {
        status: newStatus,
        partnerId: selectedDeliveryPartner.id,
      }).then((res) => {
        console.log(res.status);
        if (res?.status === 200) {
          if (newStatus === "delivery_partner_assigned") {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: `Delivery Partner Assigned Successfully`,
              life: 3000,
            });
            dispatch(updateselectedDeliveryPartner(""));
            dispatch(updateOrderModel(false));
          } else {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: `Order ${res.data.order.status} Successfully`,
              life: 3000,
            });
            dispatch(updateOrderModel(false));
          }

          // GetOrders();
          dispatch(updateUpdatedDate(item.created_on));
        }
      });
    } catch (err) {
      // console.error("Error updating status", err);
    }
  };

  const handleModalChange = (item) => {
    console.log(item);
    dispatch(updateOrderModel(true));
    dispatch(updateOrderDetails(item));
    if (item.delivery_partner_id) {
      dispatch(updateselectedDeliveryPartner(item.delivery_partner_id));
    } else {
      dispatch(updateselectedDeliveryPartner(""));
    }
  };

  const handlePartner = (partnerId) => {
    const partnerDetails = partners.filter(
      (partner) => partner.id == partnerId
    );
    if (partnerDetails.length > 0) {
      return {
        username: partnerDetails[0].username,
        deliveryTime: "Est.delivery time : 30 mins"
      };
    } else {
      return null;
    }
  };

  const downloadOrdersAsXLSX = () => {
    // Use the same filtered data that's displayed in the table
    const sourceOrders = selectedStalls.length > 0 ? displayOrders : orderList;
    
    if (!sourceOrders || sourceOrders.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "No orders available to download",
        life: 3000,
      });
      return;
    }

    // Debug: Log the first order to understand structure
    console.log("First order structure:", sourceOrders[0]);
    if (sourceOrders[0]?.cart_items) {
      console.log("Cart items structure:", sourceOrders[0].cart_items[0]);
    }

    // Get selected date range from Redux
    let dateRangeText = 'All Orders';
    
    if (selectedDate) {
      if (Array.isArray(selectedDate) && selectedDate[0] && selectedDate[1]) {
        const startDate = new Date(selectedDate[0]).toLocaleDateString();
        const endDate = new Date(selectedDate[1]).toLocaleDateString();
        dateRangeText = `${startDate} to ${endDate}`;
      } else if (selectedDate instanceof Date) {
        dateRangeText = selectedDate.toLocaleDateString();
      }
    }

    // Prepare data in the required format
    const excelData = [];
    let serialNumber = 1;

    // Apply the same filters as the table
    sourceOrders
      .filter((ord) => ord.order_id)
      .sort((a, b) => new Date(b.created_on) - new Date(a.created_on))
      .filter((ord) =>
        search !== ""
          ? ord.order_id
            .toString()
            .toLowerCase()
            .includes(search.toString().toLowerCase())
          : true
      )
      .forEach((item) => {
        // Get customer name - if no name available, use order ID
        let customerName = '';
        if (item?.user_details?.first_name || item?.user_details?.last_name) {
          customerName = `${item?.user_details?.first_name || ''} ${item?.user_details?.last_name || ''}`.trim();
        } else {
          customerName = `Order ${item.order_id}`;
        }
        
        // Get items from cart_items - matching the same logic as OrderProductsTable modal
        // The modal shows each capacity with quantity > 0 as a separate row
        let items = "N/A";
        if (item.cart_items && item.cart_items.length > 0) {
          const itemList = [];
          
          item.cart_items.forEach((cartItem) => {
            if (cartItem.products && cartItem.products.length > 0) {
              cartItem.products.forEach((product) => {
                // Find the correct product details by matching product_id
                let productDetails = null;
                if (Array.isArray(cartItem.product_details)) {
                  productDetails = cartItem.product_details.find(pd => pd.id === product.product_id);
                } else {
                  productDetails = cartItem.product_details;
                }
                
                const productName = productDetails?.item_name || 'Unknown Product';
                
                // Process each capacity with quantity > 0 (matching modal logic)
                if (product.capacity && product.capacity.length > 0) {
                  product.capacity.forEach((capacity) => {
                    // Only include capacities with quantity > 0 (same as modal)
                    if (capacity.item_quantity > 0) {
                      // Format: ProductName - Capacity (Quantity)
                      const itemString = `${productName} - ${capacity.item_capacity} (Qty: ${capacity.item_quantity})`;
                      itemList.push(itemString);
                    }
                  });
                } else {
                  // If no capacity array, just add the product name
                  itemList.push(productName);
                }
              });
            } else {
              // Fallback if no products array
              const productDetails = Array.isArray(cartItem.product_details) ? cartItem.product_details[0] : cartItem.product_details;
              if (productDetails?.item_name) {
                itemList.push(productDetails.item_name);
              }
            }
          });
          
          items = itemList.length > 0 ? itemList.join(", ") : "N/A";
        }

        /*
         * Free items claimed with the order.
         *
         * These never appeared anywhere in admin — the order stored bare offer
         * ids and nothing resolved them, so a packer had no way to know a free
         * Popcorn was meant to go in the bag. Marked "(free)" so they are not
         * mistaken for a paid line, since they contribute nothing to the total.
         */
        const claimedOffers = Array.isArray(item.claimed_offers)
          ? item.claimed_offers
          : [];
        if (claimedOffers.length) {
          const freeNames = claimedOffers
            .map((o) => o?.product_name || o?.offer_name)
            .filter(Boolean)
            .map((name) => `${name} (free)`);
          if (freeNames.length) {
            items =
              items && items !== "N/A"
                ? `${items}, ${freeNames.join(", ")}`
                : freeNames.join(", ");
          }
        }

        // Calculate amounts based on the specified formula
        const baseAmount = parseFloat(item.amount || 0);
        const selfPickupOfferAmount = parseFloat(item.self_pickup_offer_amount || 0);
        const walletOfferAmount = parseFloat(item.wallet_offer_amount || 0);
        const taxValue = parseFloat(item.tax || 0);
        
        // amount(without discount) = amount + self_pickup_offer_amount + wallet_offer_amount
        const amountWithoutDiscount = baseAmount + selfPickupOfferAmount + walletOfferAmount;
        
        // discount amount = wallet_offer_amount + self_pickup_offer_amount
        const discountAmount = walletOfferAmount + selfPickupOfferAmount;
        
        // taxable value = amount
        const taxableValue = baseAmount;
        
        // total amount = amount + tax
        const totalAmount = baseAmount + taxValue;

        // Add row to excel data
        excelData.push({
          "S.No": serialNumber++,
          "Date": formatDate(item.created_on),
          "Party name / Order Id": customerName,
          "Item": items,
          "Amount(without discount)": amountWithoutDiscount.toFixed(2),
          "Discount amount": Math.max(0, discountAmount).toFixed(2),
          "Taxable value": Math.max(0, taxableValue).toFixed(2),
          "Tax value": taxValue.toFixed(2),
          "Total amount": totalAmount.toFixed(2),
          "Order Status": item.cancel_request === true ? "Cancel Request" : item.status,
          "Payment Method": item.paymentmethod || "--"
        });
      });

    // Create workbook and worksheet
    const workbook = XLSX.utils.book_new();
    
    // Add title and metadata rows
    const titleRow = [['Shino SmartKart Hub Sales Report']];
    const dateRangeRow = [['Date Range:', dateRangeText]];
    const downloadDateRow = [['Downloaded Date:', new Date().toLocaleDateString()]];
    const emptyRow = [['']];
    
    // Create worksheet with data first
    let worksheet = XLSX.utils.json_to_sheet(excelData);
    
    // Get the range of the worksheet
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    
    // Shift all data down by 4 rows to make space for title
    const shiftedData = {};
    Object.keys(worksheet).forEach(key => {
      if (key !== '!ref') {
        const cell = XLSX.utils.decode_cell(key);
        const newKey = XLSX.utils.encode_cell({ r: cell.r + 4, c: cell.c });
        shiftedData[newKey] = worksheet[key];
      }
    });
    
    // Add title rows
    shiftedData['A1'] = { v: 'Shino SmartKart Hub Sales Report', t: 's' };
    shiftedData['A2'] = { v: 'Date Range:', t: 's' };
    shiftedData['B2'] = { v: dateRangeText, t: 's' };
    shiftedData['A3'] = { v: 'Downloaded Date:', t: 's' };
    shiftedData['B3'] = { v: new Date().toLocaleDateString(), t: 's' };
    
    // Update the range
    shiftedData['!ref'] = XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: range.e.r + 4, c: range.e.c }
    });
    
    worksheet = shiftedData;

    // Set column widths
    const columnWidths = [
      { wch: 8 },   // S.No
      { wch: 12 },  // Date
      { wch: 25 },  // Party name / Order Id
      { wch: 40 },  // Item
      { wch: 20 },  // Amount(without discount)
      { wch: 15 },  // Discount amount
      { wch: 15 },  // Taxable value
      { wch: 12 },  // Tax value
      { wch: 15 },  // Total amount
      { wch: 20 },  // Order Status
      { wch: 18 }   // Payment Method
    ];
    worksheet['!cols'] = columnWidths;

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

    // Generate filename with current date
    const currentDate = new Date().toISOString().split('T')[0];
    const fileName = `orders_${currentDate}.xlsx`;

    // Save the file
    XLSX.writeFile(workbook, fileName);

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Orders downloaded successfully",
      life: 3000,
    });
  };

  const extractProductCounts = (orders) => {
    const map = {};

    orders.forEach((order) => {
      order.cart_items.forEach((cartItem) => {
        cartItem.products.forEach((prod) => {
          const productId = prod.product_id;

          const productDetail = cartItem.product_details.find(
            (p) => p.id === productId
          );
          const productName = productDetail?.item_name || `Product ${productId}`;

          // Sum all item_quantity in capacity array; if no capacity, treat as 0
          const quantity = Array.isArray(prod.capacity)
            ? prod.capacity.reduce(
                (sum, cap) => sum + (parseInt(cap.item_quantity) || 0),
                0
              )
            : 0;

          // Skip products with non-positive total quantity
          if (!quantity || quantity <= 0) {
            return;
          }

          if (!map[productId]) {
            map[productId] = { product: productName, count: 0 };
          }

          map[productId].count += quantity;
        });
      });
    });

    return Object.values(map);
  };

  const downloadOrderProductCountAsXLSX = () => {
      // Use the same filtered data that's displayed in the table
      const baseOrders = selectedStalls.length > 0 ? displayOrders : orderList;
      
      // Apply the same filters as the table, plus exclude cancelled orders
      const sourceOrders = baseOrders
        .filter((ord) => ord.order_id)
        .filter(order => order.status !== 'cancelled')
        .sort((a, b) => new Date(b.created_on) - new Date(a.created_on))
        .filter((ord) =>
          search !== ""
            ? ord.order_id
              .toString()
              .toLowerCase()
              .includes(search.toString().toLowerCase())
            : true
        );

      if (!sourceOrders || sourceOrders.length === 0) {
        toast.current?.show?.({
          severity: "warn",
          summary: "Warning",
          detail: "No orders available to download",
          life: 3000,
        });
        return;
      }

      const groupedData = extractProductCounts(sourceOrders);

      // Convert JSON to sheet
      const worksheet = XLSX.utils.json_to_sheet(groupedData, { header: ["product", "count"], skipHeader: true, origin: 5 });
      worksheet['A5'] = { v: 'Product', t: 's' };
      worksheet['B5'] = { v: 'Count', t: 's' };
      const orderDates = sourceOrders.map(order => new Date(order.created_on));
      const minDate = new Date(Math.min(...orderDates)).toLocaleDateString();
      const maxDate = new Date(Math.max(...orderDates));
    let dateRangeText = minDate

      // if (selectedDate) {
      //   if (Array.isArray(selectedDate) && selectedDate[0] && selectedDate[1]) {
      //     const startDate = new Date(selectedDate[0]).toLocaleDateString();
      //     const endDate = new Date(selectedDate[1]).toLocaleDateString();
      //     dateRangeText = `${startDate} to ${endDate}`;
      //   } else if (selectedDate instanceof Date) {
      //     dateRangeText = selectedDate.toLocaleDateString();
      //   }
      // }
      // Add header info above the table
      worksheet['A1'] = { v: 'FoodFix Order Details', t: 's' };
      worksheet['A2'] = { v: 'Date :', t: 's' };
      // const dateRangeText = '01-10-2025 to 06-10-2025'; // replace as needed
      worksheet['B2'] = { v: dateRangeText, t: 's' };
      worksheet['A3'] = { v: 'Downloaded Date:', t: 's' };
      worksheet['B3'] = { v: new Date().toLocaleDateString(), t: 's' };

      // Add column headings at row 5 (because origin: 5)
      worksheet['A5'] = { v: 'Items', t: 's' };
      worksheet['B5'] = { v: 'Count', t: 's' };

      worksheet['!cols'] = [
        { wch: 40 }, // first column wider (Product)
        { wch: 15 }, // second column (Count)
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

      const today = new Date();
      const fileName = `order_count_${String(today.getDate()).padStart(2, "0")}-${String(today.getMonth() + 1).padStart(2, "0")}-${today.getFullYear()}.xlsx`;

      XLSX.writeFile(workbook, fileName);
    };
  const downloadKitchenReportAsXLSX = () => {
    const sourceOrders = visibleOrders.filter(
      (order) => Array.isArray(order.cart_items) && order.cart_items.length > 0
    );

    if (!sourceOrders || sourceOrders.length === 0) {
      toast.current?.show?.({
        severity: "warn",
        summary: "Warning",
        detail: "No orders available to download",
        life: 3000,
      });
      return;
    }

    const personRowsMap = new Map();
    
    sourceOrders.forEach((order) => {
      const stallName = getStallName(order);
      const personName = [
        order?.user_details?.first_name,
        order?.user_details?.last_name,
      ]
        .filter(Boolean)
        .join(" ")
        .trim() ||
        order?.user_details?.username ||
        order?.user_details?.email ||
        "--";

      order.cart_items.forEach((cartItem) => {
        const products = Array.isArray(cartItem.products)
          ? cartItem.products
          : [];

        products.forEach((product) => {
          const productDetails = Array.isArray(cartItem.product_details)
            ? cartItem.product_details.find(
                (pd) => pd.id === product.product_id
              )
            : cartItem.product_details;

          const itemName =
            productDetails?.item_name ||
            product?.product_name ||
            "Unknown Item";

          let quantity = 0;

          if (Array.isArray(product?.capacity) && product.capacity.length > 0) {
            quantity = product.capacity.reduce(
              (sum, cap) => sum + (Number(cap.item_quantity) || 0),
              0
            );
          }

          if (!quantity) {
            quantity =
              Number(product?.quantity) ||
              Number(product?.product_qty) ||
              Number(cartItem?.quantity) ||
              0;
          }

          const productCategory =
            productDetails?.item_category ||
            product?.item_category ||
            "N/A";

            if (quantity > 0) {
              const normalizedStall = stallName || "N/A";
              const normalizedPerson = personName || "--";
              const orderId = order?.order_id || order?.id || "--";
              const personKey = `${normalizedStall}|${normalizedPerson}|${orderId}`;
  
              if (!personRowsMap.has(personKey)) {
                personRowsMap.set(personKey, {
                  Stall: normalizedStall,
                  Person: normalizedPerson,
                  OrderId: orderId,
                  items: [],
                  categories: [],
                  quantities: [],
                });
              }
  
              const entry = personRowsMap.get(personKey);
              entry.items.push(itemName);
              entry.categories.push(productCategory);
              entry.quantities.push(quantity);
            }
        });
      });
    });

    const rows = Array.from(personRowsMap.values()).map((entry) => ({
      Stall: entry.Stall,
      Person: entry.Person,
      Item: entry.items.join(", "),
      Category: Array.from(new Set(entry.categories)).join(", "),
      Quantity: entry.quantities.join(", "),
    }));

    if (rows.length === 0) {
      toast.current?.show?.({
        severity: "warn",
        summary: "Warning",
        detail: "No items available to download",
        life: 3000,
      });
      return;
    }

    const worksheet = XLSX.utils.aoa_to_sheet([
      ["FoodFix Kitchen Report"],
      ["Downloaded Date:", new Date().toLocaleDateString()],
      [""],
      ["Stall", "Person", "Item", "Category", "Quantity"],
    ]);

    XLSX.utils.sheet_add_json(worksheet, rows, {
      origin: "A5",
      skipHeader: true,
      header: ["Stall", "Person", "Item", "Category", "Quantity"],
    });

    worksheet["!cols"] = [
      { wch: 25 },
      { wch: 25 },
      { wch: 20 },
      { wch: 40 },
      { wch: 12 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Kitchen");

    const today = new Date();
    const fileName = `kitchen_report_${String(today.getDate()).padStart(
      2,
      "0"
    )}-${String(today.getMonth() + 1).padStart(2, "0")}-${today.getFullYear()}.xlsx`;

    XLSX.writeFile(workbook, fileName);

    toast.current?.show?.({
      severity: "success",
      summary: "Success",
      detail: "Kitchen report downloaded successfully",
      life: 3000,
    });
    };
  return (
    <Box>
      <Toast ref={toast} />
      
      {/* Download Button(s) */}
      <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-end' }, mb: { xs: 1, sm: 2 }, gap: { xs: '8px', sm: '10px' }, flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          startIcon={<DownloadIcon sx={{ fontSize: { xs: '16px', sm: '20px' } }} />}
          onClick={downloadOrdersAsXLSX}
          sx={{
            backgroundColor: '#1976d2',
            fontSize: { xs: '12px', sm: '14px' },
            padding: { xs: '6px 12px', sm: '8px 16px' },
            '&:hover': {
              backgroundColor: '#1565c0',
            },
          }}
        >
          Download Report
        </Button>
        {isFoodfix && (
           <>
          <Button
            variant="contained"
            startIcon={<DownloadIcon sx={{ fontSize: { xs: '16px', sm: '20px' } }} />}
            onClick={downloadOrderProductCountAsXLSX}
            sx={{
              backgroundColor: '#1976d2',
              fontSize: { xs: '12px', sm: '14px' },
              padding: { xs: '6px 12px', sm: '8px 16px' },
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
            Download Orders Count
          </Button>
          <Button
              variant="contained"
              startIcon={<DownloadIcon sx={{ fontSize: { xs: '16px', sm: '20px' } }} />}
              onClick={downloadKitchenReportAsXLSX}
              sx={{
                backgroundColor: '#1976d2',
                fontSize: { xs: '12px', sm: '14px' },
                padding: { xs: '6px 12px', sm: '8px 16px' },
                '&:hover': {
                  backgroundColor: '#1565c0',
                },
              }}
            >
              Kitchen Report
            </Button>
          </>
        )}
      </Box>
      
      <TableContainer sx={{ 
        height: { xs: "50vh", sm: "55vh", md: "550px" },
        maxHeight: { xs: "65vh", sm: "65vh", md: "550px" },
        overflowX: 'auto',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          height: { xs: '4px', sm: '8px' },
          width: { xs: '4px', sm: '8px' },
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '4px',
        },
      }}>
        <Table stickyHeader aria-label="sticky table" sx={{ minWidth: { xs: 800, sm: 650 } }}>
          <TableHead style={{ backgroundColor: "background.upload" }}>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: "600",
                  textAlign: "left",
                  backgroundColor: "background.upload",
                  fontSize: { xs: "11px", sm: "14px" },
                  padding: { xs: "8px 4px", sm: "16px" },
                  whiteSpace: "nowrap"
                }}
                align="left"
              >
                S No
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  textAlign: "left",
                  backgroundColor: "background.upload",
                  fontSize: { xs: "11px", sm: "14px" },
                  padding: { xs: "8px 4px", sm: "16px" },
                  whiteSpace: "nowrap"
                }}
                align="left"
              >
                Order Id
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  textAlign: "left",
                  backgroundColor: "background.upload",
                  fontSize: { xs: "11px", sm: "14px" },
                  padding: { xs: "8px 4px", sm: "16px" },
                  whiteSpace: "nowrap"
                }}
                align="left"
              >
                Customer Details
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  textAlign: "left",
                  backgroundColor: "background.upload",
                  fontSize: { xs: "11px", sm: "14px"},
                  padding: { xs: "8px 4px", sm: "16px"},
                  whiteSpace: "nowrap"
                }}
                align="left"
              >
                Order Date & Time
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  textAlign: "left",
                  backgroundColor: "background.upload",
                  fontSize: { xs: "11px", sm: "14px" },
                  padding: { xs: "8px 4px", sm: "16px" },
                  whiteSpace: "nowrap"
                }}
                align="left"
              >
                Tax
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  textAlign: "left",
                  backgroundColor: "background.upload",
                  fontSize: { xs: "11px", sm: "14px" },
                  padding: { xs: "8px 4px", sm: "16px" },
                  whiteSpace: "nowrap"
                }}
                align="left"
              >
                Amount
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  textAlign: "left",
                  backgroundColor: "background.upload",
                  fontSize: { xs: "11px", sm: "14px" },
                  padding: { xs: "8px 4px", sm: "16px" },
                  whiteSpace: "nowrap"
                }}
                align="left"
              >
                Total Amount
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  textAlign: "left",
                  backgroundColor: "background.upload",
                  fontSize: { xs: "11px", sm: "14px" },
                  padding: { xs: "8px 4px", sm: "16px" },
                  whiteSpace: "nowrap"
                }}
                align="left"
              >
                Status
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  textAlign: "left",
                  backgroundColor: "background.upload",
                  fontSize: { xs: "11px", sm: "14px" },
                  padding: { xs: "8px 4px", sm: "16px" },
                  whiteSpace: "nowrap"
                }}
                align="left"
              >
                Payment Method
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  textAlign: "left",
                  backgroundColor: "background.upload",
                  fontSize: { xs: "11px", sm: "14px" },
                  padding: { xs: "8px 4px", sm: "16px" },
                  whiteSpace: "nowrap"
                }}
                align="left"
              >
                Delivery Partner
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleOrders.length > 0 ? (
              visibleOrders
                .filter((ord) => ord.order_id)
                .sort((a, b) => new Date(b.created_on) - new Date(a.created_on))
                .filter((ord) =>
                  search !== ""
                    ? ord.order_id
                      .toString()
                      .toLowerCase()
                      .includes(search.toString().toLowerCase())
                    : true
                )
                .map((item, ind) =>  {
                  const categoryLabel = getOrderCategoryLabel(item);
                  const isMember = !!item.is_member_order;
                  const memberBadge = item.member_badge_label || (isMember ? 'Member' : null);
                  const rowBg = isMember ? "#FDF2F8" : "white";
                  return (
                  <TableRow
                    key={item.id}
                    sx={{
                      backgroundColor: rowBg,
                      borderLeft: isMember ? "4px solid #ED1E79" : "4px solid transparent",
                    }}
                  >
                    <TableCell
                      sx={{
                        textTransform: "capitalize",
                        textAlign: "left",
                        backgroundColor: rowBg,
                        fontSize: { xs: "11px", sm: "14px", lg:"14px" },
                        padding: { xs: "8px 4px", sm: "16px" },
                      }}
                    >
                      {ind + 1}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: rowBg,
                        cursor: "pointer",
                        fontSize: { xs: "11px", sm: "14px" },
                        padding: { xs: "8px 4px", sm: "16px" },
                      }}
                      onClick={() => handleModalChange(item)}
                    >
                      <Typography sx={{ fontSize: { xs: "11px", sm: "14px" }, fontWeight: 600 }}>
                        {item.order_id}
                      </Typography>
                      {memberBadge && (
                        <Box
                          component="span"
                          sx={{
                            display: "inline-block",
                            mt: 0.5,
                            px: 1,
                            py: 0.25,
                            borderRadius: "4px",
                            backgroundColor: "#ED1E79",
                            color: "#fff",
                            fontSize: { xs: "9px", sm: "11px" },
                            fontWeight: 700,
                            lineHeight: 1.4,
                            maxWidth: "220px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={memberBadge}
                        >
                          {memberBadge}
                        </Box>
                      )}
                      {categoryLabel && (
                        <Typography sx={{ fontSize: { xs: "10px", sm: "12px" }, fontWeight: 700 }}>
                          ({categoryLabel})
                        </Typography>
                      )}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "none",
                        backgroundColor: rowBg,
                        fontSize: { xs: "11px", sm: "14px" },
                        padding: { xs: "8px 4px", sm: "16px" },
                      }}
                    >
                      <Typography sx={{ fontSize: { xs: "11px", sm: "14px" } }}>
                        {item?.user_details?.first_name + " " + item?.user_details?.last_name}
                      </Typography>
                      <Typography sx={{ fontSize: { xs: "10px", sm: "14px" } }}>
                        {item?.user_details?.mobileno}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: rowBg,
                        fontSize: { xs: "11px", sm: "14px" },
                        padding: { xs: "8px 4px", sm: "16px" },
                      }}
                    >
                      <Typography sx={{ fontSize: { xs: "11px", sm: "14px" }, fontWeight: "500" }}>
                        {formatDate(item.created_on)}
                      </Typography>
                      <Typography sx={{ fontSize: { xs: "9px", sm: "12px" }, color: "text.secondary" }}>
                        {formatTime(item.created_on)}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: rowBg,
                        fontSize: { xs: "11px", sm: "14px" },
                        padding: { xs: "8px 4px", sm: "16px" },
                      }}
                    >
                      Rs {item.tax}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: rowBg,
                        fontSize: { xs: "11px", sm: "14px" },
                        padding: { xs: "8px 4px", sm: "16px" },
                      }}
                    >
                      Rs {item.amount}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: rowBg,
                        fontSize: { xs: "11px", sm: "14px" },
                        padding: { xs: "8px 4px", sm: "16px" },
                      }}
                    >
                      Rs {item.total_amount}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: rowBg,
                        fontSize: { xs: "11px", sm: "14px" },
                        padding: { xs: "8px 4px", sm: "16px" },
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: "left",
                          width: { xs: "120px", sm: "200px" },
                          height: { xs: "28px", sm: "32px" },
                          backgroundColor:
                            item.status === "declined"
                              ? "#FFF1F2"
                              : item.status === "delivered" || item.status === "picked"
                                ? "#F6FFED"
                                : item.status === "pending"
                                  ? "#E6F1F8"
                                  : item.status === "delivery_partner_assigned" ||
                                    item.status === "order_picked_up" ||
                                    item.status === "accepted"
                                    ? "#FFF7EB"
                                    : "#F9FAFB",
                          padding: { xs: "3px 4px", sm: "5px" },
                          fontSize: { xs: "9px", sm: "12px" },
                          color:
                            item.status === "declined"
                              ? "#E11D48"
                              : item.status === "delivered" || item.status === "picked"
                                ? "#52C41A"
                                : item.status === "pending"
                                  ? "#0071BC"
                                  : item.status === "delivery_partner_assigned" ||
                                    item.status === "order_picked_up" ||
                                    item.status === "accepted"
                                    ? "#FBB03B"
                                    : item.status === "cancelled"
                                      ? "red"
                                      : "#6B7280",
                          borderColor:
                            item.status === "declined"
                              ? "#E11D48"
                              : item.status === "delivered"
                                ? "#F6FFED"
                                : item.status === "pending"
                                  ? "#E6F1F8"
                                  : item.status === "delivery_partner_assigned"
                                    ? "#FBB03B"
                                    : item.status === "cancelled"
                                      ? "red"
                                      : "#F9FAFB",
                          border: "1px solid",
                          display: "flex",
                          alignItems: "center",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}
                      >
                        {item.cancel_request === true ? "Cancel Request" : showStallFilter ?  item.status=='ready_for_pickup' ? 'Out For Delivery' : item.status:item.status}
                      </Box>
                    </TableCell>
                    <TableCell
                    sx={{
                      textAlign: "left",
                      textTransform: "capitalize",
                      backgroundColor: rowBg,
                      fontSize: { xs: "11px", sm: "14px" },
                      padding: { xs: "8px 4px", sm: "16px" },
                    }}
                  >
                    {getPaymentDisplay(item)}
                  </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "left",
                        textTransform: "capitalize",
                        backgroundColor: rowBg,
                        fontSize: { xs: "11px", sm: "14px" },
                        padding: { xs: "8px 4px", sm: "16px" },
                      }}
                    >
                      {handlePartner(item.delivery_partner_id) ? (
                        <Box>
                          <Typography sx={{ fontSize: { xs: "11px", sm: "14px" }, fontWeight: "500", lineHeight: "22px" }}>
                            {handlePartner(item.delivery_partner_id).username}
                          </Typography>
                          <Typography sx={{ fontSize: { xs: "9px", sm: "12px" }, fontWeight: "500", lineHeight: "22px" }}>
                            {handlePartner(item.delivery_partner_id).deliveryTime}
                          </Typography>
                        </Box>
                      ) : (
                        <Box>-- --</Box>
                      )}
                    </TableCell>
                  </TableRow>

                )})
            ) : (
              <TableRow>
                {showSkeletonPlaceholder ? (
                  <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: { xs: "150px", sm: "200px" }, fontWeight: "700" }} colSpan={11}>
                    <Box>
                      <Box sx={{ width: { xs: "100%", sm: "80%" } }}>
                        <Skeleton animation="wave" sx={{ height: { xs: "40px", sm: "60px" }, background: "rgb(0 0 0 / 6%)" }} />
                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                      </Box>
                      <Box sx={{ width: { xs: "100%", sm: "80%" } }}>
                        <Skeleton animation="wave" sx={{ height: { xs: "40px", sm: "60px" }, background: "rgb(0 0 0 / 6%)" }} />
                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                      </Box>
                      <Box sx={{ width: { xs: "100%", sm: "80%" } }}>
                        <Skeleton animation="wave" sx={{ height: { xs: "40px", sm: "60px" }, background: "rgb(0 0 0 / 6%)" }} />
                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                      </Box>
                    </Box>
                  </TableCell>
                ) : (
                  <TableCell
                    sx={{
                      textAlign: "center",
                      textTransform: "capitalize",
                      backgroundColor: "white",
                      height: { xs: "150px", sm: "200px" },
                      fontWeight: "600",
                      fontSize: { xs: "12px", sm: "14px" },
                    }}
                    colSpan={11}
                  >
                    No orders Available
                  </TableCell>
                )}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
